import { env } from '../env';

export const DEFAULT_LANDING_PATH = env.REACT_DEFAULT_LANDING_PATH;

export const BASE_URL = env.REACT_APP_BASE_URL;
export const BASE_API_URL = env.REACT_APP_API_BASE_URL;
export const TRPC_BASE_URL = env.REACT_APP_TRPC_BASE_URL;
export const MMX_BASE_URL = env.REACT_APP_MMX_FRONT_URL;

export const CONTAINER_URL = window.location.hostname.includes('localhost')
  ? `${BASE_API_URL}/containers/mmxservicesstorage/download`
  : env.REACT_APP_S3_CONTAINER_URL;

export const CONTAINER = 'mmxservicesstorage';

type TUser = 'users' | 'Companies';

export const USER_API_PATH: TUser = env.REACT_APP_USER_API_PATH;

export const COUNTRY_PREFIXES = [
  { value: '52', name: 'México', conekta: 'mx', regionCode: 'MX' },
  { value: '54', name: 'Argentina', conekta: 'ar', regionCode: 'AR' },
  { value: '501', name: 'Belice', conekta: 'be', regionCode: 'BE' },
  { value: '591', name: 'Bolivia', conekta: 'bo', regionCode: 'BO' },
  { value: '56', name: 'Chile', conekta: 'ch', regionCode: 'CH' },
  { value: '1', name: 'Canada', conekta: 'ca', regionCode: 'CA' },
  { value: '57', name: 'Colombia', conekta: 'co', regionCode: 'CO' },
  { value: '506', name: 'Costa Rica', conekta: 'cr', regionCode: 'CR' },
  { value: '53', name: 'Cuba', conekta: 'cu', regionCode: 'CU' },
  { value: '593', name: 'Ecuador', conekta: 'ec', regionCode: 'EC' },
  { value: '1', name: 'Estados Unidos', conekta: 'eu', regionCode: 'US' },
  { value: '34', name: 'España', conekta: 'es', regionCode: 'ES' },
  { value: '503', name: 'El Salvador', conekta: 'el', regionCode: 'SV' },
  { value: '502', name: 'Guatemala', conekta: 'gu', regionCode: 'GT' },
  { value: '240', name: 'Guinea Ecuatorial', conekta: 'ge', regionCode: 'GQ', },
  { value: '504', name: 'Honduras', conekta: 'ho', regionCode: 'HN' },
  { value: '505', name: 'Nicaragua', conekta: 'ni', regionCode: 'NI' },
  { value: '507', name: 'Panamá', conekta: 'pa', regionCode: 'PA' },
  { value: '595', name: 'Paraguay', conekta: 'pa', regionCode: 'PY' },
  { value: '51', name: 'Perú', conekta: 'pe', regionCode: 'PE' },
  { value: '1787', name: 'Puerto Rico', conekta: 'pr', regionCode: 'PR' },
  { value: '1809', name: 'República Dominicana', conekta: 're', regionCode: 'DO', },
  { value: '598', name: 'Uruguay', conekta: 'ur', regionCode: 'UY' },
  { value: '58', name: 'Venezuela', conekta: 've', regionCode: 'VE' },
  { value: '1', name: 'United States', conekta: 'eu', regionCode: 'US' },
  { value: '-', name: 'Otro', regionCode: 'ZZ' },
];

export const countries = [
  {
    code: '52',
    name: 'México',
    conekta: 'mx',
    regionCode: 'MX',
    translate_prefix: 'es-mx',
    currency: 'MXN',
    currency_symbol: '$',
    iva_label: 'IVA',
    rfc_label: 'RFC',
    sat_label: 'SAT',
    flag: '🇲🇽'
  },
  {
    code: '54',
    name: 'Argentina',
    conekta: 'ar',
    regionCode: 'AR',
    translate_prefix: 'es-mx',
    currency: 'ARS',
    currency_symbol: '$',
    iva_label: 'Impuestos',
    rfc_label: '',
    flag: '🇦🇷'
  },
  {
    code: '501',
    name: 'Belice',
    conekta: 'be',
    regionCode: 'BE',
    translate_prefix: 'es-mx',
    currency: 'BZD',
    currency_symbol: 'BZ$',
    iva_label: 'Impuestos',
    rfc_label: '',
    flag: '🇧🇿'
  },
  {
    code: '591',
    name: 'Bolivia',
    conekta: 'bo',
    regionCode: 'BO',
    translate_prefix: 'es-mx',
    currency: 'BOB',
    currency_symbol: '$b',
    iva_label: 'Impuestos',
    rfc_label: '',
    flag: '🇧🇴'
  },
  {
    code: '55',
    name: 'Brasil',
    conekta: 'br',
    regionCode: 'BR',
    translate_prefix: 'port',
    currency: 'BRL',
    currency_symbol: 'R$',
    iva_label: 'Impuestos',
    rfc_label: '',
    flag: '🇧🇷'
  },
  {
    code: '56',
    name: 'Chile',
    conekta: 'ch',
    regionCode: 'CH',
    translate_prefix: 'es-mx',
    currency: 'CLP',
    currency_symbol: '$',
    iva_label: 'Impuestos',
    rfc_label: '',
    flag: '🇨🇱'
  },
  {
    code: '1',
    name: 'Canada',
    conekta: 'ca',
    regionCode: 'CA',
    translate_prefix: 'en-us',
    currency: 'CAD',
    currency_symbol: '$',
    iva_label: 'Impuestos',
    rfc_label: '',
    flag: '🇨🇦'
  },
  {
    code: '57',
    name: 'Colombia',
    conekta: 'co',
    regionCode: 'CO',
    translate_prefix: 'es-mx',
    currency: 'COP',
    currency_symbol: '$',
    iva_label: 'Impuestos',
    rfc_label: '',
    flag: '🇨🇴'
  },
  {
    code: '506',
    name: 'Costa Rica',
    conekta: 'cr',
    regionCode: 'CR',
    translate_prefix: 'es-mx',
    currency: 'CAD',
    currency_symbol: '$',
    iva_label: 'Impuestos',
    rfc_label: '',
    flag: '🇨🇷'
  },
  {
    code: '53',
    name: 'Cuba',
    conekta: 'cu',
    regionCode: 'CU',
    translate_prefix: 'es-mx',
    currency: 'CAD',
    currency_symbol: '₱',
    iva_label: 'Impuestos',
    rfc_label: '',
    flag: '🇨🇺'
  },
  {
    code: '593',
    name: 'Ecuador',
    conekta: 'ec',
    regionCode: 'EC',
    translate_prefix: 'es-mx',
    currency_symbol: '$',
    iva_label: 'Impuestos',
    rfc_label: 'RUC',
    sat_label: 'SRI',
    flag: '🇪🇨'
  },
  {
    code: '1',
    name: 'Estados Unidos',
    conekta: 'eu',
    regionCode: 'US',
    translate_prefix: 'en-us',
    currency: 'USD',
    currency_symbol: '$',
    iva_label: 'VAT',
    rfc_label: 'Tax ID',
    flag: '🇺🇸'
  },
  {
    code: '34',
    name: 'España',
    conekta: 'es',
    regionCode: 'ES',
    translate_prefix: 'es-mx',
    currency: 'EUR',
    currency_symbol: '€',
    iva_label: 'Impuestos',
    rfc_label: '',
    flag: '🇪🇸'
  },
  {
    code: '503',
    name: 'El Salvador',
    conekta: 'el',
    regionCode: 'SV',
    translate_prefix: 'es-mx',
    currency: 'SVC',
    currency_symbol: '$',
    iva_label: 'Impuestos',
    rfc_label: '',
    flag: '🇸🇻'
  },
  {
    code: '502',
    name: 'Guatemala',
    conekta: 'gu',
    regionCode: 'GT',
    translate_prefix: 'es-mx',
    currency: 'GTQ',
    currency_symbol: 'Q',
    iva_label: 'Impuestos',
    rfc_label: '',
    flag: '🇬🇹'
  },
  {
    code: '240',
    name: 'Guinea Ecuatorial',
    conekta: 'ge',
    regionCode: 'GQ',
    translate_prefix: 'es-mx',
    currency_symbol: '$',
    iva_label: 'Impuestos',
    rfc_label: '',
    flag: '🇬🇶'
  },
  {
    code: '504',
    name: 'Honduras',
    conekta: 'ho',
    regionCode: 'HN',
    translate_prefix: 'es-mx',
    currency: 'HNL',
    currency_symbol: 'L',
    iva_label: 'Impuestos',
    rfc_label: '',
    flag: '🇭🇳'
  },
  {
    code: '505',
    name: 'Nicaragua',
    conekta: 'ni',
    regionCode: 'NI',
    translate_prefix: 'es-mx',
    currency: 'NIO',
    currency_symbol: 'C$',
    iva_label: 'Impuestos',
    rfc_label: '',
    flag: '🇳🇮'
  },
  {
    code: '507',
    name: 'Panamá',
    conekta: 'pa',
    regionCode: 'PA',
    translate_prefix: 'es-mx',
    currency: 'PAB',
    currency_symbol: 'B/.',
    iva_label: 'Impuestos',
    rfc_label: '',
    flag: '🇵🇦'
  },
  {
    code: '595',
    name: 'Paraguay',
    conekta: 'pa',
    regionCode: 'PY',
    translate_prefix: 'es-mx',
    currency: 'PYG',
    currency_symbol: 'Gs',
    iva_label: 'Impuestos',
    rfc_label: '',
    flag: '🇵🇾'
  },
  {
    code: '51',
    name: 'Perú',
    conekta: 'pe',
    regionCode: 'PE',
    translate_prefix: 'es-mx',
    currency: 'PEN',
    currency_symbol: 'S/.',
    iva_label: 'Impuestos',
    rfc_label: '',
    flag: '🇵🇪'
  },
  {
    code: '1787',
    name: 'Puerto Rico',
    conekta: 'pr',
    regionCode: 'PR',
    translate_prefix: 'es-mx',
    currency: 'PEN',
    currency_symbol: '$',
    iva_label: 'Impuestos',
    rfc_label: '',
    flag: '🇵🇷'
  },
  {
    code: '1',
    name: 'República Dominicana',
    conekta: 're',
    regionCode: 'DO',
    translate_prefix: 'es-mx',
    currency: 'DOP',
    currency_symbol: 'RD$',
    iva_label: 'Impuestos',
    rfc_label: '',
    flag: '🇩🇴'
  },
  {
    code: '598',
    name: 'Uruguay',
    conekta: 'ur',
    regionCode: 'UY',
    translate_prefix: 'es-mx',
    currency: 'UYU',
    currency_symbol: '$U',
    iva_label: 'Impuestos',
    rfc_label: '',
    flag: '🇺🇾'
  },
  {
    code: '58',
    name: 'Venezuela',
    conekta: 've',
    regionCode: 'VE',
    translate_prefix: 'es-mx',
    currency: 'VEF',
    currency_symbol: 'Bs',
    iva_label: 'Impuestos',
    rfc_label: '',
    flag: '🇻🇪'
  },
  {
    code: '1',
    name: 'United States',
    conekta: 'eu',
    regionCode: 'US',
    translate_prefix: 'en-us',
    currency: 'USD',
    currency_symbol: '$',
    iva_label: 'VAT',
    rfc_label: 'Tax ID',
    flag: '🇺🇸'
  },
  {
    code: '-',
    name: 'Otro',
    regionCode: 'ZZ',
    translate_prefix: 'es-mx',
    flag: ''
  }
];

export const KYC_KEYS = {
  position: {
    show: true,
    label: 'Qué posición tienes en la empresa?',
    options: [
      'Dueño',
      'Jefe de Taller',
      'Asistente administrativo',
      'Técnico',
      'Otro',
    ]
  },
  employeesQuantity: {
    show: true,
    label: 'Cuántos empleados son?',
    options: [
      'Soy solo yo',
      'de 2 a 5',
      '6 a 10',
      '11 a 15',
      '16 o más',
      'Todavía ninguno',
    ]
  },
  hasAssistant: {
    show: true,
    label: 'Cuentas con asistente administrativo?',
    options: [
      'Sí',
      'No',
    ],
  },
  weeklyServices: {
    show: true,
    label: 'Cuántos servicios realizas a la semana?',
    options: [
      '1 - 5',
      '6 - 15',
      '16 - 30',
      '31 o más',
    ],
  },
  automationOptions: {
    show: false,
    label: 'Qué buscas solucionar?',
    multiple: true,
    options: [
      'Impulsar mis ventas',
      'Llevar control de servicios',
      'Mejorar mi trato al cliente',
      'Innovar con tecnología',
      'Controlar mis inventarios',
      'Mejorar la productividad',
      'Llevar control de ingresos y egresos',
      'Abrir mi negocio',
      'Todas las anteriores',
    ],
  },
  yearsOpen: {
    show: true,
    label: 'Cuánto tiempo lleva tu empresa?',
    options: [
      'Todavía no abrimos',
      'Menos de 1 año',
      '3 a 5 años',
      'Más de 5 años',
    ],
  },
  administrativos: {
    show: false,
    label: 'Cuántas personas funcionan como administrativos?',
    options: [
      'Sólo yo',
      '2',
      '3',
      '4',
      '5-10',
      'Más de 10',
    ],
  },
  changingSoftware: {
    show: false,
    label: 'Te estás cambiando de plataforma por algún motivo?',
    options: [
      'Obsoleto',
      'Mal Soporte',
      'Requiero nuevas funciones',
      'No me es útil',
      'NO APLICA',
    ],
  },
  support: {
    show: false,
    label: 'Cómo preferirías el soporte al cliente?',
    options: [
      'Autocapacitación con tutoriales',
      'Capacitación personal en línea',
      'Implementación en mi empresa',
    ],
  },
  isPriceDecisive: {
    show: false,
    label: 'El precio del programa es importante para ti?',
    options: [
      'Sí',
      'No',
    ],
  },
  servicesTypes: {
    show: true,
    label: 'Qué tipo de servicios ofrece tu taller?',
    multiple: true,
    options: [
      'Reparaciones y Matenimiento',
      'Detallado, envolturas y películas',
      'Restauración y Personalización',
      'Otros',
    ],
  },
  vehiclesTypes: {
    show: true,
    label: 'A qué tipo de vehículos das servicio?',
    multiple: true,
    options: [
      'Autos',
      'Semi y Pesados',
      'Trailers',
      'Caravanas',
      'Motos',
      'Bicis',
      'Botes',
    ],
  },
  lookingToSolve: {
    show: true,
    label: 'Qué buscas resolver?',
    multiple: true,
    options: [
      'Servicio al Cliente',
      'Aumentar Postventa',
      'Mejorar la administración',
      'Productividad del personal',
    ],
  },
  currentManagement: {
    show: true,
    label: 'Hoy cómo gestionas tu taller?',
    options: [
      'Papel',
      'Excel',
      'Uso una App/Software',
    ],
  },
};

export const STATUS_LABEL = {
  'ServiceStatus.RECEIVED': 'Recibida',
  'ServiceStatus.IN_PROGRESS': 'En progreso',
  'ServiceStatus.FINISHED': 'Terminado',
  'ServiceStatus.DELIVERED': 'Entregado',
  'ServiceStatus.CANCELLED': 'Cancelado',
  'ServiceStatus.AUTHORIZED': 'Autorizado',
  'ServiceStatus.QUOTES': 'Cotización'
};

export const APPOINTMENT_STATUS = [
  { label: "Solicitada por el cliente", id: 0 },
  { label: "Confirmada", id: 1 },
  { label: "Declinada", id: 2 },
  { label: "No atendida ( cliente no llegó )", id: 3 }
];


export const ORDER_TYPES = {
  1: 'Servicio',
  2: 'Garantia',
  3: 'Retorno',
  4: 'Venta',
  5: 'Preventivo',
  6: 'Correctivo',
  7: 'Rescate vial',
};